import {Stack, Typography} from '@mui/material';
import {Modal} from 'presentation/components/Modal';
import {Loading} from 'presentation/components/Loading/Loading';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {AutoSearchLoadingDialogProps} from './types';

const {refundNumberWithProtocol, autoSearchLoadingDescription} =
	translations['pt-br'].privateFlow.refund.additionalDocuments.searchProtocol;

export const AutoSearchLoadingDialog = ({open}: AutoSearchLoadingDialogProps) => (
	<Modal.Root open={open} disableEscapeKeyDown>
		<Modal.Content>
			<Stack alignItems="center" textAlign="center" gap={2} py={2}>
				<Loading size={48} minHeight="auto" />
				<Typography variant="h6" color="text.primary">
					{refundNumberWithProtocol}
				</Typography>
				<Typography variant="body2" color="text.secondary">
					{autoSearchLoadingDescription}
				</Typography>
			</Stack>
		</Modal.Content>
	</Modal.Root>
);
